import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme/simple.css';
import './theme/prison.css';
import './theme/abc.css';
import './theme/rail.css';
import './theme/select.css';
import './theme/docs.css';
import './theme/admin.css';
import './design/tokens.css';
import { App } from './App';
import { startKeepAlive } from './core/keepAlive';

// A sensible default before the API tells us the player's style; App updates
// data-theme once me.style is known. Each style's token block re-tints every
// shared screen, so the components and core logic are unchanged (spec §7).
document.documentElement.dataset.theme = 'simple';

// Warm the serverless backend as early as possible so the first real API call
// (auth/me, current round) isn't waiting on a cold start.
startKeepAlive();

// Auth uses MSAL redirect flow: when the tab returns from Entra with an auth response
// in the URL, App's first API call runs initMsal() → handleRedirectPromise(), which
// completes sign-in before rendering the app. No popup, so no boot guard needed.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
